export const ENV_VAR = {
    CUSTOMER_PRODUCT_JOB_CONTACT_NUMBER: process.env.REACT_APP_CUSTOMER_PRODUCT_JOB_CONTACT_NUMBER ?? "7909921367",
    OLA_MAPS_API_KEY: process.env.REACT_APP_OLA_MAPS_API_KEY,
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
};